import { api } from '../../config/api'
import {
  FOOD,
  POPULAR_FOOD,
  FOOD_DETAILS
} from '../../actions/actionTypes'

export const getFood = () => (dispatch, getState) => {
  const { lang, lasted } = getState()
  if (lasted !== getState().food.list[lang].lastUpdate || !getState().food.list[lang].data.length) {
    dispatch({ type: FOOD.REQUEST })
    return (
      fetch(api.food+'?language='+lang)
      .then(res => res.json())
      .then((res) => {
        dispatch({ type: FOOD.SUCCESS, data: res, lang, lasted })
      })
      .catch((err) => {
        dispatch({ type: FOOD.FAILURE, error: err })
      })
    )
  }
}

export const getPoppularFood = () => (dispatch, getState) => {
  const { lang, lasted } = getState()
  if (lasted !== getState().food.popular[lang].lastUpdate || !getState().food.popular[lang].data.length) {
    dispatch({ type: POPULAR_FOOD.REQUEST })
    return (
      fetch(api.foodPopular+'?language='+lang)
      .then(res => res.json())
      .then((res) => {
        dispatch({ type: POPULAR_FOOD.SUCCESS, data: res, lang, lasted })
      })
      .catch((err) => {
        dispatch({ type: POPULAR_FOOD.FAILURE, error: err })
      })
    )
  }
}

export const getFoodDataById = (id) => (dispatch, getState) => {
  const { lang, lasted } = getState()
  dispatch({ type: FOOD_DETAILS.REQUEST, lang })
  return (
    fetch(api.food+'/'+id+'?language='+lang)
    .then(res => res.json())
    .then((res) => {
      dispatch({ type: FOOD_DETAILS.SUCCESS, data: res, lang, lasted })
    })
    .catch((err) => {
      dispatch({ type: FOOD_DETAILS.FAILURE, error: err })
    })
  )
}


// WEBPACK FOOTER //
// ./src/containers/Food/actions.js